module.exports = __webpack_public_path__ + "resources/sass/fn/fonts/OpenSans-LightItalic-webfont.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/sass/fn/fonts/OpenSans-LightItalic-webfont.svg
// module id = 352
// module chunks = 0